import React from 'react';
import Error from './Error'
import { usePermissions } from 'react-admin';

const Authorization = (WrappedComponent, param) => {
    const WithAuthorization = (props) => {
        const { permissions, loaded } = usePermissions();
        if (!loaded) return null
        if (permissions) {
            permissions.functionAction = permissions.functionAction || [];
            if (!props.basePath.includes('/user') || props.match.params.id === undefined) {
                if (param.action === 'isRead') {
                    if (!permissions.functionAction.find(value => value.function === param.functionName && (value.isRead || value.isUpdate || value.isCreate || value.isDelete)))
                        return <Error />
                }
                else if (!permissions.functionAction.find(value => value.function === param.functionName && value[param.action])) {
                    return <Error />
                }


            }
            else if (localStorage.getItem('id') != props.match.params.id) {
                if (param.action === 'isRead') {
                    if (!permissions.functionAction.find(value => value.function === param.functionName && (value.isRead || value.isUpdate || value.isCreate || value.isDelete)))
                        return <Error />
                }
                else if (!permissions.functionAction.find(value => value.function === param.functionName && value[param.action])) {
                    return <Error />
                }
            }

            return <WrappedComponent {...props} />
        }
    }
    return WithAuthorization
}
export default Authorization